import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Why from "./pages/Why";
import SpeakerBios from "./pages/SpeakerBios";
import BecomeSpeaker from "./pages/BecomeSpeaker";
import BecomeVolunteer from "./pages/BecomeVolunteer";
import HostEvent from "./pages/HostEvent";
import BotEvents from "./pages/BotEvents";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/why" element={<Why />} />
            <Route path="/speaker-bios" element={<SpeakerBios />} />
            <Route path="/become-a-speaker" element={<BecomeSpeaker />} />
            <Route path="/become-a-volunteer" element={<BecomeVolunteer />} />
            <Route path="/host-a-bot-event" element={<HostEvent />} />
            <Route path="/bot-events" element={<BotEvents />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
